// extracted by mini-css-extract-plugin
export default {"subTitle":"ReturnCheckList_subTitle__qKFaW","box":"ReturnCheckList_box__CdGUd","divider":"ReturnCheckList_divider__Ks9tz"};